module.exports = __webpack_public_path__ + "images/_/programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_yay.png
// module id = 2301
// module chunks = 2